import "@/App.css";
import {
  ArrowRight,
  CheckCircle2,
  Headphones,
  Heart,
  Sparkles,
  Sunrise,
} from "lucide-react";

const BRAND_LOGO =
  "https://academy.modernagemonk.com/v2/_next/image?url=https%3A%2F%2Ftagmango.com%2Fstaticassets%2F-chatgpt-image-aug-17-2026-12_44_54-pm-1-3c07746a5f30cc03a066257908e1a54d.png&w=96&q=75";

const VIP_SPECIAL_OFFER_IMAGE =
  "https://tagmango.com/assets/premium-vip-special-offer-0d4a770f58385a9b6be6d3cd0c25469e.png";

const VIP_RESOURCE_IMAGES = {
  morning:
    "https://tagmango.com/assets/morning-meditation-at-sunrise-2c51cf7d171af0de29119e8ebb5c7635.png",
  healing:
    "https://tagmango.com/assets/release-negative-energy-ae477600b4ae919f6e233bf40b92d7bc.png",
  affirmations:
    "https://tagmango.com/assets/reprogram-your-life-affirmations-health-and-love-c3c9d2eefb56efc8b214a67de5ff78fa.png",
};

const vipResources = [
  {
    icon: Sunrise,
    image: VIP_RESOURCE_IMAGES.morning,
    imageAlt: "Morning Meditation sunrise ritual visual",
    title: "Morning Manifestation Ritual",
    value: "₹999",
    text: "Start your day with guided manifestation, clear intentions, and positive visualization to build a consistent morning practice.",
    testId: "morning-ritual-resource-card",
  },
  {
    icon: Heart,
    image: VIP_RESOURCE_IMAGES.healing,
    imageAlt: "Release Negative Energy guided healing visual",
    title: "Guided Healing Experience",
    value: "₹7,999",
    text: "A guided experience to help you process difficult emotions, practise self-compassion, and support your emotional well-being.",
    testId: "guided-healing-resource-card",
  },
  {
    icon: Headphones,
    image: VIP_RESOURCE_IMAGES.affirmations,
    imageAlt: "Reprogram affirmations for money health and relationships visual",
    title: "Handpicked Affirmation Collection",
    value: "₹11,999",
    text: "A curated collection of written and audio affirmations for abundance, self-worth, relationships, and success.",
    testId: "affirmation-collection-resource-card",
  },
];

const vipPracticeBenefits = [
  "Start practising before your live workshop.",
  "Get resources you can revisit whenever you want.",
  "Build a simple daily healing and manifestation routine.",
];

function ResourceCard({ icon: Icon, image, imageAlt, title, value, text, testId }) {
  return (
    <article className="benefit-card" data-testid={testId}>
      <div className="resource-image-frame" data-testid={`${testId}-image-frame`}>
        <img src={image} alt={imageAlt} data-testid={`${testId}-image`} />
      </div>
      <div className="benefit-icon" aria-hidden="true" data-testid={`${testId}-icon`}>
        <Icon size={22} strokeWidth={2.2} />
      </div>
      <div className="benefit-copy">
        <div className="resource-title-row">
          <h4 data-testid={`${testId}-title`}>{title}</h4>
          <span className="resource-value" data-testid={`${testId}-value`}>Value: {value}</span>
        </div>
        <p data-testid={`${testId}-description`}>{text}</p>
      </div>
    </article>
  );
}

function App() {
  return (
    <div className="thankyou-page" data-testid="thankyou-page">
      <header className="site-header" data-testid="site-header">
        <a className="brand-mark" href="#free-confirmation" data-testid="brand-home-link">
          <img
            src={BRAND_LOGO}
            alt="Pratyussh Patil Modern Age Monk logo"
            data-testid="creator-logo-image"
          />
          <span data-testid="creator-brand-name">Pratyussh Patil</span>
        </a>
      </header>

      <main className="page-flow" data-testid="thankyou-main-content">
        <section
          className="confirmation-section"
          id="free-confirmation"
          aria-labelledby="confirmation-title"
          data-testid="free-confirmation-section"
        >
          <div className="confirmation-shell">
            <div className="checkmark-wrap" aria-hidden="true" data-testid="registration-checkmark">
              <CheckCircle2 size={54} strokeWidth={1.9} />
            </div>
            <h1 id="confirmation-title" data-testid="confirmation-heading">
              🎉 Congratulations! You're Registered!
            </h1>
            <p className="confirmation-lead" data-testid="confirmation-seat-message">
              Aapki FREE Healing &amp; Manifestation Workshop ki seat confirm ho gayi hai! ✅
            </p>
            <p className="vip-scroll-prompt" data-testid="vip-scroll-or-whatsapp-message">
              🎁 <strong>Special VIP Offer!</strong> Dekhne ke liye neeche scroll karein.
            </p>
            <p className="whatsapp-message" data-testid="whatsapp-join-message">
              VIP offer skip karke FREE workshop join karna chahte hain? Neeche button par click karein!
            </p>
            <a
              className="whatsapp-cta"
              href="https://go.abundanceliving.in/vtrcommunity"
              data-testid="join-whatsapp-group-button"
            >
              🟢 JOIN FREE WORKSHOP WHATSAPP GROUP
            </a>
          </div>
        </section>

        <section
          className="vip-section"
          id="vip-upgrade"
          aria-labelledby="vip-title"
          data-testid="vip-upgrade-section"
        >
          <div className="vip-panel">
            <div className="special-offer-hero" data-testid="vip-special-offer-hero">
              <img
                src={VIP_SPECIAL_OFFER_IMAGE}
                alt="Special offer upgrade to VIP with Pratyussh Patil"
                data-testid="vip-special-offer-image"
              />
            </div>

            <div className="vip-intro" data-testid="vip-intro-copy">
              <p className="vip-kicker" data-testid="vip-upgrade-label">
                <Sparkles size={16} aria-hidden="true" /> OPTIONAL VIP UPGRADE
              </p>
              <h2 id="vip-title" data-testid="vip-heading">
                Unlock Your Exclusive VIP Manifestation Experience ✨
              </h2>
              <p className="vip-description" data-testid="vip-experience-description">
                Aapki manifestation journey ko next level par le jaane ke liye, get access to these
                exclusive resources.
              </p>
            </div>

            <div className="benefits-block" data-testid="vip-resources-block">
              <h3 data-testid="vip-resources-heading">Inside Your VIP Experience</h3>
              <div className="benefit-grid" data-testid="vip-benefits-list">
                {vipResources.map((resource) => (
                  <ResourceCard key={resource.title} {...resource} />
                ))}
              </div>
            </div>

            <div className="practice-benefits" data-testid="vip-practice-benefits">
              {vipPracticeBenefits.map((benefit) => (
                <div className="practice-benefit" key={benefit} data-testid={`vip-benefit-${benefit.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}>
                  <CheckCircle2 size={18} aria-hidden="true" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <p className="application-highlight" data-testid="vip-application-highlight">
              Your FREE workshop helps you learn. Your VIP experience helps you start applying what you learn.
            </p>

            <div className="price-block" id="vip-payment-placeholder" data-testid="vip-price-section">
              <div className="assigned-values" data-testid="assigned-values-list">
                <p data-testid="morning-assigned-value">Morning Manifestation Ritual — ₹999</p>
                <p data-testid="healing-assigned-value">Guided Healing Experience — ₹7,999</p>
                <p data-testid="affirmation-assigned-value">Handpicked Affirmation Collection — ₹11,999</p>
                <strong data-testid="total-assigned-value">Total Assigned Value: ₹20,997</strong>
              </div>
              <div className="gold-divider" aria-hidden="true" data-testid="vip-gold-divider" />
              <div className="price-stack" data-testid="vip-price-details">
                <p className="offer-label" data-testid="vip-offer-label">Your VIP Upgrade Today</p>
                <p className="special-price" data-testid="special-vip-price">₹299 Only</p>
              </div>
              <a className="vip-cta" href="https://academy.modernagemonk.com/web/checkout/6acc7578c13c0d954fb33ef6" data-testid="vip-upgrade-button">
                YES! UPGRADE ME TO VIP <ArrowRight size={20} aria-hidden="true" />
              </a>
              <p className="payment-note" data-testid="payment-supporting-text">
                One-time payment. Access your resources after successful payment.
              </p>
              <p className="optional-note" data-testid="vip-optional-note">
                Your free workshop registration is already confirmed. VIP is completely optional.
              </p>
              <a className="skip-link" href="https://go.abundanceliving.in/vtrcommunity" data-testid="skip-vip-link">
                No thanks, I will continue with my FREE workshop.
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="site-footer" data-testid="site-footer">
        <p data-testid="footer-brand-note">Modern Age Monk • Healing &amp; Manifestation Workshop</p>
      </footer>
    </div>
  );
}

export default App;